export const ROLES = {
    ADMIN: "ROLE_SUPER_ADMIN",
    USER: "ROLE_USER_BASIC",
    AGGREGATOR: "ROLE_AGGREGATOR",
}
